import { Link } from 'react-router-dom';

import mussel from '../../assets/images/mussel3creamblurbright700.png';

function Quality() {
  return (
    <div className="about__quality-container">
      <div className="about__quality-wrapper column">
        <div className="about__quality-title">
          <h1>핵심은 바로 고품질의 성분</h1>
        </div>
        <div className="about__quality-content row">
          <div className="about__quality-box">
            <img src={mussel} alt="green lipped mussel" />
          </div>
          <div className="about__quality-box column">
            <div className="about__quality-text">
              <p>
                저희 제품은 천연의 재료를 수확하는 순간부터 세심하게
                다루어집니다. 이후, 신선도 유지를 위해 적절한 처리를 거쳐
                포장되는 과정들을 통해 내용물을 보호하고, 사용될 때 까지
                신선도를 유지할 수 있게 만듭니다.
              </p>
              <p>
                저희 제품은 뉴질랜드에서도 가장 높이 평가되는 업체로부터 재료를
                공급받습니다. 무엇보다도 최고의 제품군을 위해 지속적으로 제품의
                제조법을 연구하고 개선해 나가고 있습니다.
              </p>
            </div>
            <div className="about__quality-button">
              <Link to="/products">
                <button className="about__button">제품보기</button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Quality;
